// vuex
// src\store\index.ts
// https://vuex.vuejs.org/guide/#the-simplest-store
import { createStore } from "vuex";
import * as Types from "@/types";

export interface State {
  count: number;
  device_list: Types.T_DEVICE[];
}

export default createStore<State>({
  state: {
    count: 0,
    device_list: [],
  },
  getters: {},
  mutations: {
    increment(state) {
      state.count++;
    },
    device_list(state, param) {
      state.device_list = param;
    },
  },
  actions: {},
  modules: {},
});
